<h1 mat-dialog-title>{{ 'field.workInstructionHistory' | translate }}</h1>
<mat-dialog-content>
  <mat-card>
    <mat-card-content class="p-0">
      <app-datatable
        class="work-instruction-history"
        [configurationInput]="datatableConfigurations"
        [rowData]="workInstructionHistory"
        [columns]="datatableColumns"
        [total]="this.store.dataTotal$()"
        [customColumnDef]="[{ name: 'changedValues', template: changedValues, isSortable: false }]"
        (dataRefreshRequest)="datatableParams$.next($event)"
      />
    </mat-card-content>
  </mat-card>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button matButton="tonal" mat-dialog-close>
    {{ 'button.close' | translate }}
  </button></mat-dialog-actions
>

<ng-template #changedValues let-row="row">
  <div *ngFor="let change of row.changedValues" class="mt-1 mb-2">
    <div class="change-field">{{ change.field }}</div>
    <div class="change-container">
      <div class="change-details">
        <div class="before-field">
          <ng-container *ngIf="change.key === 'status' && change.before !== noneText; else textBefore">
            <mat-pill [ngClass]="{ green: change.before === completed }" [text]="change.before"></mat-pill>
          </ng-container>
          <ng-template #textBefore>
            {{ change.before }}
          </ng-template>
        </div>
        <mat-icon class="arrow-icon">arrow_forward</mat-icon>
        <div class="after-field">
          <ng-container *ngIf="change.key === 'status' && change.after !== noneText; else textAfter">
            <mat-pill [ngClass]="{ green: change.after === completed }" [text]="change.after"></mat-pill>
          </ng-container>
          <ng-template #textAfter>
            {{ change.after }}
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</ng-template>
